import { render, staticRenderFns } from "./DesignPropertiesForm.vue?vue&type=template&id=f7c707d6&scoped=true&"
import script from "./DesignPropertiesForm.vue?vue&type=script&lang=js&"
export * from "./DesignPropertiesForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignPropertiesForm.vue?vue&type=style&index=0&id=f7c707d6&scoped=true&lang=css&"
import style1 from "./DesignPropertiesForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7c707d6",
  null
  
)

export default component.exports